function escapeHTML(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function escapeAttr(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function sanitizeURL(url) {
  try {
    const parsed = new URL(url, window.location.origin);
    return ["http:", "https:"].includes(parsed.protocol) ? parsed.href : "";
  } catch {
    return "";
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.js-compare-products-modal');
  const modalContent = document.querySelector('.js-compare-products-modal-content');
  window.removeCompareProductsState = false
  window.totalSearchResult = 0;

  window.toggleModal = () => {
    if (modal) {
      const isHidden = modal.classList.contains('hidden');
      document.body.classList.toggle('overflow-hidden', isHidden);
      modal.classList.toggle('hidden');
    }
  };

  window.addEventListener('click', (e) => {
    if (modalContent && e.target.classList.contains('js-compare-products-modal') && e.target !== modalContent) {
      window.toggleModal();
    }
  });
})

window.addEventListener('load', () => {
  const navigationType = performance.getEntriesByType('navigation')[0].type;
  if (navigationType !== 'reload') {
    localStorage.removeItem('compareProducts');
  }
})

const settings = window.searchTabSettings || {};
let lastSentPage = -1;

const filterSettings = window.filterSettings || {};


document.addEventListener("algolia.hooks.initialize", function () {
  let algoliaShopify = window.algoliaShopify;
  let allZeroPrice = 0;

  // Replace 'myCookie' with the actual cookie name
  const rawCookieValue = getCookieValue('OptanonConsent');
  if (rawCookieValue) {
    // 2. Extract the 'groups' value from the cookie string
    const params = new URLSearchParams(rawCookieValue);
    const groups = params.get('groups'); // e.g., "1:1,2:1,3:1,4:1,5:1"

    if (groups) {
      // 3. Parse the 'groups' string into key-value pairs
      const groupObj = {};
      groups.split(',').forEach(pair => {
        const [key, value] = pair.split(':');
        groupObj[key] = value;
      });

      // 4. Get the value for key "2"
      const valueOf2 = groupObj["2"];
      if (valueOf2 == 0) {
        algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function (options) {
          options.insights = false;
          return options;
        });
        algoliaShopify.hooks.registerHook('beforeAlgoliaAnalyticsOptions', function (options) {
          options.userHasOptedOut = true;
          options.useCookie = false;
          return options;
        });
      }
      if (valueOf2 == 1) {
        algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function (options) {
          options.insights = true;
          return options;
        });
        algoliaShopify.hooks.registerHook('beforeAlgoliaAnalyticsOptions', function (options) {
          options.userHasOptedOut = false;
          options.useCookie = true;
          return options;
        });
      }

    } else {
      console.log("No 'groups' key found in cookie.");

      algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function (options) {
        options.insights = false;
        return options;
      });
      algoliaShopify.hooks.registerHook('beforeAlgoliaAnalyticsOptions', function (options) {
        options.userHasOptedOut = true;
        options.useCookie = false;
        return options;
      });
    }
  } else {
    console.log("Cookie not found.");

    algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function (options) {
      options.insights = false;
      return options;
    });
    algoliaShopify.hooks.registerHook('beforeAlgoliaAnalyticsOptions', function (options) {
      options.userHasOptedOut = true;
      options.useCookie = false;
      return options;
    });
  }


  algoliaShopify.hooks.registerHook('beforeISTransformItems',
    function () {
      const hits = Array.prototype.slice.call(arguments).pop();
      if (!Array.isArray(hits) || !hits.length) return hits;

      const pageIdx = getPageFromUrl();
      if (pageIdx !== lastSentPage) {
        pushViewItemList(hits, pageIdx);
        lastSentPage = pageIdx;
      }
      return hits;
    }
  );

  function getPageFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get('page') || '1', 10) - 1;
  }

  function pushViewItemList(hits, pageIdx) {
    const ctx = window?.bdData?.collection || {};
    const searchQuery = window?.bdData?.search?.query;

    const baseName = window?.bdData?.search
      ? `Search results for '${searchQuery}'`
      : ctx.title || 'Collection';

    const baseId = window?.bdData?.search
      ? `search`
      : ctx.handle;

    const listName = pageIdx === 0
      ? baseName
      : `${baseName} | page ${pageIdx + 1}`;

    const items = hits.map((hit, i) => {
      const item = {
        item_id: hit.objectID,
        item_name: hit.title,
        item_brand: hit.vendor,
        item_category: hit.product_type,
        price: hit.price,
        item_list_id: baseId,
        item_list_name: listName,
        index: i
      };
      if (hit.variants_count > 1 && hit.variant_title) {
        item.item_variant = hit.variant_title;
      }
      return item;
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: baseId,
        item_list_name: listName,
        items
      }
    });
  }

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteNoResultsTemplate",
    function (_defaultTemplate, templateOptions) {
      const { html, state } = templateOptions;

      if (state.query === "") return;

      let products = window.saleItems?.length
        ? window.saleItems.map((item, index) => { // Corrected map function syntax
          return html`<li class="aa-Item" id="autocomplete-0-saleItems-item-${index}" role="option" aria-selected="false">
        <a href="/products/${item.handle}/?variant=${item.variant_id}" class="aa-ItemLink aa-ProductItem">
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img src="${item.product_image}" srcset="${item.product_image}" width="125px" height="125px"
                alt="${item.title}" />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentBrand">bev<span> by </span>BLACK+DECKER</div>
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">${item.title}<span class="algolia-variant"> </span></div>
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">${html`${renderProductPriceCard(item, html)}`}</div>
              </div>
            </div>
          </div>
        </a>
      </li>`;
        })
        : null;


      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
         <span class="TermsLayout">${window.BARREL.algoliaTermsText}</span>

          <p class="aa-NoResultsHeader">
            No results were found. Try searching for something else.
          </p>

          ${products && html`<div class="aa-PanelSection">
          <section class="aa-Source" data-autocomplete-source-id="saleItems">
            <div class="aa-SourceHeader">
              <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">Recommended Products</span>
                  <div class="aa-SourceHeaderLine"></div>
              </div>
            </div>
              <ul class="aa-List" role="listbox" aria-labelledby="autocomplete-0-label"
                id="autocomplete-0-saleItems-list">
                  ${products}
              </ul>
              </section>
            </div>`}
        </div>
      `;
    }
  );


  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    // Don't return the default template and return a custom two-column layout instead


    return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
        <span class="TermsLayout">${window.BARREL.algoliaTermsText}</span>

        ${(elements.collections || elements.articles || elements.pages || elements.redirectUrlPlugin || elements.products)
        ?
        html` <div class="aa-PanelSections">
          ${(elements.collections || elements.articles || elements.pages || elements.redirectUrlPlugin) &&
          html`<div class="aa-PanelSection--left ${elements?.products ? "" : "aa-PanelSection--left--noright"}">
              ${displaySuggestions &&
            html`
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle"
                      >{algoliaShopify.translations.suggestions}</span
                    >
                    <div class="aa-SourceHeaderLine" />
                  </div>
                  {elements.querySuggestionsPlugin}
                `}
              ${elements.collections} ${elements.articles} ${elements.pages}
              ${elements.redirectUrlPlugin}
            </div>`
          }
          ${elements.products &&
          html`<div class="${elements.collections || elements.articles || elements.pages || elements.redirectUrlPlugin ? "aa-PanelSection--right" : "aa-PanelSection"}">
            ${elements.products}
          </div>`
          }
          </div>`
        : html`<p class="aa-NoResultsHeader">
            No results were found. Try searching for something else.
          </p>
        <div class="aa-PanelSection">
          ${elements.saleItems}
        </div>`}
        </div>
      `;
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteMainProductsTemplate', function (_defaultTemplate, templateOptions, elements) {
    const { html } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
       <span class="TermsLayout">${window.BARREL.algoliaTermsText}</span>

        <div class="aa-PanelSection">
          ${elements.products}
        </div>
      </div>
    `;
  });



  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      return html`
      <a
        href="${itemLink}"
        class="aa-ItemLink aa-ProductItem"
        onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"

      >
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded">
             <img src="${item.product_image}" srcset="${item.product_image}" width="125px" height="125px" alt="${item.title}" />
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentBrand">
              ${item.product_type &&
        components.Highlight({ hit: item, attribute: "product_type" })
        }
             removing vendor
            </div>
            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: "title" })}
                <span class="algolia-variant">
                  ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                </span>
              </div>
            </div>
            <div class="aa-ItemContentPrice">
              <div class="aa-ItemContentPriceCurrent">${html`${renderProductPriceCard(item, html)}`}</div>
            </div>
          </div>
        </div>
      </a>
    `;
    }
  );




  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
    // Change the placeholder text of the autocomplete menu
    options.placeholder = "Enter Search Term";

    //     const { searchClient } = window.algoliaShopify;
    //     const { getAlgoliaResults } = window.algoliaShopify.externals;

    //     const saleItemsPlugin = {
    //       name: 'custom-sale-items-plugin',
    //       getSources({ query }) {
    //         return [
    //           {
    //             sourceId: "saleItems",
    //             getItems() {
    //               return getAlgoliaResults({
    //                 searchClient,
    //                 queries: [{
    //                   indexName: `${algoliaShopify.config.index_prefix}products`,
    //                   params: {
    //                     query: `${window.BARREL.algoliaTermsQuery ? window.BARREL.algoliaTermsQuery : ""}`,
    //                     hitsPerPage: window.BARREL.algoliaTermsHitsPerPage ? window.BARREL.algoliaTermsHitsPerPage : 6,

    //                   },
    //                 }]
    //               })
    //             },
    //             templates: {
    //               header({ html, state }) {
    //                 return html`
    //                   <div class="aa-SourceHeader">
    //                     <span class="aa-SourceHeaderTitle">${window.BARREL.algoliaTermsTitle ? window.BARREL.algoliaTermsTitle : ""}</span>
    //                     <div class="aa-SourceHeaderLine" />
    //                   </div>`;
    //               },
    //               item({ item, components, html }) {

    //                 return html`
    //                 <a href="/products/${item.handle}/?variant=${item.objectID}" class="aa-ItemLink aa-ProductItem">

    //  <div class="aa-ItemContent">
    //  <div class="aa-ItemPicture aa-ItemPicture--loaded">
    //             <img src="${item.product_image}" srcset="${item.product_image}" width="125px" height="125px" alt="${item.title}" /></div>
    // <div class="aa-ItemContentBody">
    //                <div class="aa-ItemContentBrand">bev<span> by </span>BLACK+DECKER</div>
    //                <div class="aa-ItemContentTitleWrapper">
    //                   <div class="aa-ItemContentTitle">${item.title}<span class="algolia-variant"> </span></div>
    //                </div>
    //                <div class="aa-ItemContentPrice">

    //                     <div class="aa-ItemContentPriceCurrent">${html`${renderProductPriceCard(item, html)}`}</div>
    //                </div>
    //             </div>
    //          </div>

    // </a>
    // `;
    //               }
    //             }
    //           },
    //         ];
    //       },
    //     };
    //     options.plugins.push(saleItemsPlugin);

    async function fetchPopularProducts() {
      const query = `query($first: Int $query: String){
        products(first: $first, query: $query) {
          nodes {
            id
            title
            tags
            handle
            featuredImage {
              url
            }
            productType
            totalInventory
            variants(first: 1) {
              nodes {
                id
                availableForSale
                price{
                  amount
                }
                compareAtPrice{
                  amount
                }
              }
            }
          }
        }
      }`;
      const replaceGid = (gid) => {
        return Number(gid.split('/').at(-1))
      }

      let algoliaTermsQuery = window.BARREL.algoliaTermsQuery ? `tag:${window.BARREL.algoliaTermsQuery}` : "";
      let hitsPerPage = window.BARREL.algoliaTermsHitsPerPage ? window.BARREL.algoliaTermsHitsPerPage : 6;
      const data = await storefrontClient(query, { first: hitsPerPage, query: algoliaTermsQuery }, '2024-01');
      const products = data.data ? data.data.products.nodes.map(e => {
        let variant = e.variants.nodes[0];
        return {
          id: replaceGid(e.id),
          variant_id: replaceGid(variant.id),
          title: e.title,
          handle: e.handle,
          product_image: e.featuredImage.url,
          can_order: variant.availableForSale,
          price: Number(variant?.price?.amount),
          compare_at_price: Number(variant?.compareAtPrice?.amount),
          inventory_available: e.totalInventory > 0,
          product_type: e.productType,
          tags: e.tags
        }
      }) : {};
      return products;
    }
    fetchPopularProducts().then(products => {
      window.saleItems = products
    })
    return options;
  });

  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
    const { ratingMenu, numericMenu } = window.instantsearch.widgets;
    const ratingContainerSelector = '.ais-Consumer.Rating';
    // const runtimeContainerSelector = '.ais-facet-meta\\.Salsify\\.run_time_';
    // const dustbinCapacityContainerSelector = '.ais-facet-meta\\.Salsify\\.dustbin_capacity_';

    const widgets = [];

    if (document.querySelector(ratingContainerSelector)) {
      const ratingWidget = ratingMenu({
        container: ratingContainerSelector,
        attribute: 'meta.BazaarVoice.Rating',
        templates: {
          item(data, options) {
            return `
          <a
            href="javascript:void(0)"
            class="${data.cssClasses.link}"
            aria-label="${data.name} & up">
            ${data.stars.map(isFilled =>
              isFilled
                ? `<svg class="w-[14px] h-[14px] mt-[-2px] mr-[2px]" xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"><path fill="#D6001C" d="m7.193.353 1.614 4.97h5.226L9.806 8.394l1.614 4.97-4.227-3.071-4.228 3.071 1.615-4.97L.352 5.323h5.226L7.193.353Z" /></svg>`
                : `<svg class="w-[14px] h-[14px] mt-[-2px] mr-[2px]" xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"><path fill="#D2D2D2" d="m7.55.353 1.615 4.97h5.226l-4.228 3.071 1.615 4.97-4.228-3.071-4.228 3.071 1.615-4.97L.71 5.323h5.226L7.55.353Z" /></svg>`
            ).join('')}
            <span class="${data.cssClasses.label} mleft-1 -translate-y-[2px] lg:-translate-y-[1px]"> & Up</span>
            <span class="${data.cssClasses.count} hide hidden">${data.count}</span>
          </a>
        `;
          }
        }
      });
      widgets.push(ratingWidget);
    } else {

      console.warn(`Rating widget container not found: ${ratingContainerSelector}`);
    }

    function filterMenuItemsByAvailableValues(menuItems, availableValues) {
      return menuItems.filter(item => {
        if (!item.start && !item.end) return true; // "All"
        return availableValues.some(val => {
          if (item.start && item.end) {
            return val >= item.start && val < item.end;
          } else if (item.start) {
            return val >= item.start;
          } else if (item.end) {
            return val < item.end;
          }
          return false;
        });
      });
    }

    // if (document.querySelector(runtimeContainerSelector)) {

    //   const runTimeMenuItems = [
    //     { label: 'All' },
    //     { label: 'Up to 15 Minutes', end: 15 },
    //     { label: '15 - 30 Minutes', start: 15, end: 30 },
    //     { label: '30 – 60 Minutes', start: 30, end: 60 },
    //     { label: 'Over 60 Minutes', start: 60 },
    //   ];


    //   const runTimeWidget = numericMenu({
    //     container: runtimeContainerSelector,
    //     attribute: 'meta.Salsify.run_time_',
    //     items: runTimeMenuItems,

    //     transformItems(items, { results }) {
    //       if (results && results.facets) {
    //         const runTimeFacet = results.facets.find(f => f.name === 'meta.Salsify.run_time_');
    //         if (runTimeFacet) {
    //           const availableRunTimes = Object.keys(runTimeFacet.data).map(Number);

    //           // Filter the items based on available values
    //           const filteredRunTimeMenuItems = filterMenuItemsByAvailableValues(runTimeMenuItems, availableRunTimes);
    //           return items.filter(item =>
    //             filteredRunTimeMenuItems.find(filteredItem => filteredItem.label === item.label)
    //           );
    //         }
    //       }
    //       // Fallback: show all items if no facet data
    //       return items;
    //     }

    //   });

    //   widgets.push(runTimeWidget);
    // } else {
    //   console.warn(`Run-time widget container not found: ${runtimeContainerSelector}`);
    // }


    // if (document.querySelector(dustbinCapacityContainerSelector)) {
    //   const dustbinItems = [
    //     { label: 'All' },
    //     { label: 'Up to 200 ml', end: 200 },
    //     { label: '200 - 300 ml', start: 200, end: 300 },
    //     { label: '300 - 400 ml', start: 300, end: 400 },
    //     { label: '400 - 500 ml', start: 400, end: 500 },
    //     { label: 'Over 500 ml', start: 500 },
    //   ];
    //   const dustbinCapacityTimeWidget = numericMenu({
    //     container: dustbinCapacityContainerSelector,
    //     attribute: 'meta.Salsify.dustbin_capacity_',
    //     items: dustbinItems,

    //     transformItems(items, { results }) {
    //       if (results && results.facets) {
    //         const runTimeFacet = results.facets.find(f => f.name === 'meta.Salsify.dustbin_capacity_');
    //         if (runTimeFacet) {
    //           const availableRunTimes = Object.keys(runTimeFacet.data).map(Number);

    //           // Filter the items based on available values
    //           const filteredDustbinItems = filterMenuItemsByAvailableValues(dustbinItems, availableRunTimes);
    //           return items.filter(item =>
    //             filteredDustbinItems.find(filteredItem => filteredItem.label === item.label)
    //           );
    //         }
    //       }
    //       // Fallback: show all items if no facet data
    //       return items;
    //     }
    //   });

    //   widgets.push(dustbinCapacityTimeWidget);
    // } else {
    //   console.warn(`dustbinCapacityTimeWidget widget container not found: ${dustbinCapacityContainerSelector}`);
    // }
    addDynamicCSS(filterSettings);
    Object.entries(filterSettings).forEach(([key, cfg]) => {
      if (!cfg.containerSelector || !cfg.menuLabel || !cfg.menuItems) {
        console.warn(`Skipping ${key}, missing required properties`);
        return;
      }

      const containerSelector = buildContainerSelector(cfg.containerSelector);

      if (document.querySelector(containerSelector)) {
        const menuItems = parseMenuItems(cfg.menuItems, cfg.menuLabel);

        const widget = numericMenu({
          container: containerSelector,
          attribute: `meta.${cfg.containerSelector}`,
          items: menuItems,

          transformItems(items, { results }) {
            if (results && results.facets) {
              const facet = results.facets.find(f => f.name === `meta.${cfg.containerSelector}`);
              if (facet) {
                const availableValues = Object.keys(facet.data).map(Number);
                const filtered = filterMenuItemsByAvailableValues(menuItems, availableValues);
                return items.filter(item => filtered.find(f => f.label === item.label));
              }
            }
            return items;
          }
        });

        widgets.push(widget);

      } else {
        console.warn(`${key} widget container not found: ${containerSelector}`);
      }
    });
    return widgets;

  });


  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchStatsTemplate",
    function (_defaultTemplate, data, html) {
      window.totalSearchResult = algoliaShopify.helpers.formatNumber(data.nbHits);
      return html`
        ${data.hasOneResult &&
        html` <span class="ais-stats--nb-results text-sm !font-normal"> result for "${data.query}" </span> `}
        ${data.hasManyResults &&
        html`
          <span class="ais-stats--nb-results text-sm !font-normal">
            results for
            ${" "} "${data.query}"
          </span>
        `}
        ${data.nbPages < 2 &&
        html`<style>
          .ais-pagination-container {
            display: none !important;
          }
        </style>`}
        ${data.nbHits === 0 &&
        html`<style>
            .ais-page .ais-sort,
            .ais-page .ais-facets,
            .ais-page .ais-facets-button,
            .ais-page .ais-search-header,
            .ais-page .ais-facets-Filter-wrapper {
              display: none !important;
            }

            .ais-page .ais-data-result {
              width: 100% !important;
            }

          .template-search .ais-page .ais-block {
            width: 100% !important;
            padding: 0 !important;
          }
          .template-search .ais-page .ais-stats-container {
            margin-bottom: 20px;
          }
          </style>
          <p class="ais-stats-search-query"> results for "${data.query}"</p>
          `
        }
        ${data.nbHits > 0 &&
        html`<style>
            .template-search .ais-page .ais-input {
              margin-bottom: 20px;
            }
          </style>`
        }
      `;
    }
  );



  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFiltersString",
    function (defaultFilter) {
      if (defaultFilter && defaultFilter.includes("collection_ids")) {
        const collectionIDFilterRegex = /collection_ids:"\w+"/g;
        const matches = window.location.pathname.match(
          /\/collections\/([^/]+)/i
        );
        const collectionHandle =
          matches && matches.length === 2 ? matches[1] : null;
        if (collectionHandle) {
          return defaultFilter.replace(
            collectionIDFilterRegex,
            "collections:" + collectionHandle
          );
        }
      }
      return defaultFilter;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFacetItemTemplate",
    function (_defaultTemplate, item, html) {

      if (item.attribute === "tags" && item.value === "zeropriceproduct") {
        // Check if all products in this range have a price of 0
        allZeroPrice = item.count;
      }
      if (item.attribute === "price_range" && item.value === "0:10") {
        if (allZeroPrice === item.count) {
          localStorage.setItem('allZeroPrice', allZeroPrice);
          return html`<label class="${item.cssClasses.label} zero-price_range-disable"></label>`;
        } else if (allZeroPrice === 0 && localStorage.getItem('allZeroPrice')) {
          allZeroPrice = parseInt(localStorage.getItem('allZeroPrice')) || 0;
          if (allZeroPrice == item.count) {
            return html`<label class="${item.cssClasses.label} zero-price_range-disable"></label>`;
          } else {
            localStorage.removeItem('allZeroPrice');
          }
        } else {
          localStorage.removeItem('allZeroPrice');
        }
      }

      return html`
      <label class="${item.cssClasses.label}">
        ${item.type === "disjunctive" &&
        (item.isRefined
          ? html`
              <input
                type="checkbox"
                class="${item.cssClasses.checkbox}"
                checked
              />
            `
          : html`
              <input type="checkbox" class="${item.cssClasses.checkbox}" />
            `)}

            ${(item.attribute === "price_range" && item.value === "0:10" ? html`$10 & Below` : `${escapeHTML(item.label)}`)}

        ${(item.attribute === "product_type" ?
          html`<span class="${item.cssClasses.count}  ">
                        (${algoliaShopify.helpers.formatNumber(item.count)})
                      </span>`
          :
          html`<span class="${item.cssClasses.count}  hide hidden">
                        (${algoliaShopify.helpers.formatNumber(item.count)})
                      </span>`
        )}
      </label>
    `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchMainTemplate",
    function (_defaultTemplate, data, html) {
      const indexPrefix = window.algoliaShopify.config.index_prefix
      return html`
        <div class="ais-page flex flex-wrap no-result is-loading">
          <div class="w-full ais-page-SearchBox-container">
          ${!algoliaShopify.is_collection_results_page
          ? html`<h1 class="h2 mb-[8px] w-full !hidden">${algoliaShopify.translations.searchTitle}</h1>` : ''
            }
            <div class="ais-stats-container w-full !block"></div>
            <div class="w-full max-w-[400px] !mt-[16px] lg:!mt-[20px] !hidden">
              <div class="ais-search-box-container !flex"></div>
              <div class="ais-input-button">
                <div class="ais-clear-input-icon"></div>
              </div>
            </div>
          </div>
          <div class="ais-block">
            <div class="ais-header-wrapper">
              <div class="ais-tabs">
                <button class="js-ais-tab ais-tab active" data-tab="${indexPrefix}products">${settings.products.label ? settings.products.label : 'Products'} (<span class="js-ais-tab-product-count"></span>)</button>
                ${settings.pages.enabled ? html`<button class="js-ais-tab ais-tab" data-tab="${indexPrefix}pages">${settings.pages.label ? settings.pages.label : 'Pages'} (<span class="js-ais-tab-page-count">0</span>)</button>` : ''}
                ${settings.articles.enabled ? html`<button class="js-ais-tab ais-tab" data-tab="${indexPrefix}articles_faq">${settings.articles.label ? settings.articles.label : 'FAQs'} (<span class="js-ais-tab-article-count">0</span>)</button>` : ''}
              </div>
              <div class="ais-search-header">
                <div class="ais-change-display">
                  <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
                  <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
                </div>
                <div class="ais-sort">
                  ${data.multipleSortOrders
          ? html`
                      <div class="ais-sort-orders-container"></div>
                    `
          : html`
                      ${algoliaShopify.translations.relevance}
                  `}
                </div>
              </div>
            </div>
            <div class="js-ais-data ais-data js-results-group results-${indexPrefix}products" data-tab="${indexPrefix}products">
              <div class="ais-facets-Filter-wrapper [.no-result_&]:!hidden">
                <button type="button" class="ais-facets-button h5">Filters +</button>
                <div class="ais-facets ais-facets-Filter">
                  <div class="ais-clear-refinements-container"></div>
                  <div class="ais-current-refined-values-container"></div>
                  ${data.facets.map(
            (facet) =>
              html`
                        <div
                          class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName} ais-${facet.title}"
                        >
                          <label
                            for="${facet.escapedName}"
                            class="ais-range-slider--header ais-facet--header ais-header cursor-pointer">
                            ${facet.title}
                          </label>
                          <input
                            class="ais-dropdown-checkbox"
                            type="checkbox"
                            id="${facet.escapedName}"
                            name="dropdown"
                          />
                          <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                        </div>
                      `
          )}
                </div>
              </div>
              <div class="ais-data-result transition-opacity opacity-100 [.is-loading_&]:!opacity-0">
                <div class="ais-hits-container ais-results-as-block"></div>
                <div class="ais-pagination-container"></div>
              </div>
            </div>
            ${window.templateName === 'search' ? html`
              <div class="js-results-group results-group-pages results-${indexPrefix}pages"></div>
              <div class="js-results-group results-group-articles results-${indexPrefix}articles_faq">
                <accordion-list>
                  <div class="accordion__container">
                    <ul class="accordion__wrapper js-custom-wrapper">
                    </ul>
                  </div>
                </accordion-list>
              </div>
            ` : html``}
          </div>
        </div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchNoResultTemplate",
    function (_defaultTemplate, html) {
      return html`
        <div class="ais-hit-empty !mb-[40px] !pt-[40px] !lg:mb-[50px] !lg:pt-[100px]">
          <h3 class="ais-hit-empty--content text-left text-2md font-semibold lg:text-lg">No results were found. Please try searching for something else.</h3>
        </div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (_defaultTemplate, hit, html, components) {
      const MOQ_tag = hit.tags.find((s) => s.includes("MOQ_"));
      let MOQ = 0;
      if (MOQ_tag) {
        MOQ = Number(MOQ_tag.split("_")[1] || 0);
      }
      let ctaButton;

      if (hit.can_order && hit.product_type === "Bundle") {
        ctaButton = html`
          <button
            class="btn-primary cursor-pointer w-full max-w-[183px] px-4 !m-0 h-[45px]"
            data-form-id="algolia-add-to-cart-${hit.objectID}"
          >
            View Details
          </button>
        `;
      } else if (hit.can_order && hit.product_type !== "Bundle") {
        ctaButton = html`
          <button
            class="btn-primary cursor-pointer w-full max-w-[183px] px-4 !m-0 h-[45px]"
            data-form-id="algolia-add-to-cart-${hit.objectID}"
          >
            ${algoliaShopify.translations.addToCart}
          </button>
        `;
      } else if (hit.product_type === "Bundle") {
        ctaButton = html`<button
          className="btn-primary cursor-pointer w-full max-w-[183px] px-4 !m-0 h-[45px] pointer-events-none"
          disabled
        >
          Coming Soon
        </button>`;
      } else {
        ctaButton = html`<a
          href="${sanitizeURL(algoliaShopify.helpers.instantsearchLink(hit))}"
          className="btn-primary cursor-pointer w-full max-w-[183px] px-4 !m-0 h-[45px]"
        >
          View Details
        </a>`;
      }

      return html`
        <div class="ais-Hits-item-card">
          <div
            class="ais-hit ais-product override js-product-card"
            data-algolia-index="${hit.index || hit.__hitIndex || ''}"
            data-algolia-position="${hit.__position || hit.productPosition || ''}"
            data-algolia-queryid="${hit.__queryID || hit.queryID || ''}"
            data-algolia-objectid="${hit.objectID}"
            data-handle="${hit.handle}"
            data-variant-id="${hit.objectID}"
            data-distinct="${hit._distinct}"
            data-product-id="${hit.id}"
            data-qty="${MOQ || 1}"
            data-title="${escapeAttr(hit.title)}"
            data-wishlist-id=""
            data-available="${hit.can_order}"
            data-product-json="${escapeAttr(JSON.stringify(hit))}"

          >
            <a href="${sanitizeURL(algoliaShopify.helpers.instantsearchLink(hit))}" class="absolute inset-0 block w-full h-full z-[1]" aria-label="${escapeAttr(hit.title)} - ${escapeAttr(hit.sku)}"></a>
            <div class="ais-hit--wishlist" data-heart-filled="false" role="button" tabindex="0">
              <span class="wishlist__heart-full" data-fill="false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.647 2.2788C11.342 2.2788 10.0895 2.8863 9.27197 3.8463C8.45447 2.8863 7.20197 2.2788 5.89697 2.2788C3.58697 2.2788 1.77197 4.0938 1.77197 6.4038C1.77197 9.2388 4.32197 11.5488 8.18447 15.0588L9.27197 16.0413L10.3595 15.0513C14.222 11.5488 16.772 9.2388 16.772 6.4038C16.772 4.0938 14.957 2.2788 12.647 2.2788Z"
                    fill="#000"
                  />
                </svg>
                <span class="sr-only">Added to wishlist</span>
              </span>
              <span class="wishlist__heart-empty ">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.77197 3.81749C10.5895 2.85749 11.842 2.24999 13.147 2.24999C15.457 2.24999 17.272 4.06499 17.272 6.37499C17.272 9.20767 14.7262 11.5162 10.869 15.0139L10.8595 15.0225L9.77197 16.0125L8.68447 15.03L8.65486 15.0031C4.80895 11.5082 2.27197 9.20274 2.27197 6.37499C2.27197 4.06499 4.08697 2.24999 6.39697 2.24999C7.70197 2.24999 8.95447 2.85749 9.77197 3.81749ZM9.77198 13.9875L9.84698 13.9125C13.417 10.68 15.772 8.54253 15.772 6.37503C15.772 4.87503 14.647 3.75003 13.147 3.75003C11.992 3.75003 10.867 4.49253 10.477 5.52003H9.07448C8.67698 4.49253 7.55198 3.75003 6.39698 3.75003C4.89698 3.75003 3.77198 4.87503 3.77198 6.37503C3.77198 8.54253 6.12698 10.68 9.69698 13.9125L9.77198 13.9875Z"
                    fill="#BDBDBD"
                  />
                </svg>
                <span class="sr-only">Add to wishlist</span>
              </span>
            </div>

            <img
              class="ais-hit--picture"
              src="${sanitizeURL(hit.product_image)}"
              alt="${escapeAttr(hit.title)} - ${escapeAttr(hit.variant_title)}"
            />

            <div class="ais-hit--details">
              <p class="ais-hit--vendor productcard-ais--badges">
                ${hit.tags && hit.tags.length > 0 && ProductBadges(hit, html)}
              </p>

              <p class="ais-hit--sku">${hit.sku}</p>
              <p class="ais-hit--title override">
                <a
                  data-algolia-index="${hit.index || hit.__hitIndex || ''}"
                  data-algolia-position="${hit.__position || hit.productPosition || ''}"
                  data-algolia-queryid="${hit.__queryID || hit.queryID || ''}"
                  data-algolia-objectid="${hit.objectID}"
                  href="${sanitizeURL(algoliaShopify.helpers.instantsearchLink(hit))}"
                  aria-label="${algoliaShopify.helpers.fullTitle(
        hit.title,
        hit._distinct,
        hit.variant_title
      )} - ${hit.sku}"
                >
                  ${components.Highlight({ attribute: "title", hit })}
                  ${algoliaShopify.helpers.variantTitleAddition(
        hit,
        hit._distinct
      )}
                </a>
              </p>
              <p class="ais-hit--price">
                ${html`${renderProductPriceCard(hit, html)}`}
              </p>
              <p class="ais-hit--moq">
                ${MOQ > 1 ? html` Must buy in multiples of ${MOQ} ` : html``}
              </p>
              ${!hit._distinct &&
        html`
                <form
                  id="algolia-add-to-cart-${hit.objectID}"
                  style="display: none;"
                  action="/cart/add"
                  method="post"
                  enctype="multipart/form-data"
                >
                  <input type="hidden" name="id" value="${hit.objectID}" />

                  ${MOQ > 1
            ? html`
                        <input type="hidden" name="quantity" value="${MOQ}" />
                      `
            : html` <input type="hidden" name="quantity" value="1" /> `}
                </form>
                <p class="ais-hit--cart js-cta-button">${html`${ctaButton}`}</p>
              `}
              ${html`<div
                className="mt-1.5 bv-rating--hide-number ${hit?.meta?.BazaarVoice
            ?.Rating <= 0
            ? "bv-rating-custom-hide-zero"
            : ""}"
                data-bv-show="inline_rating"
                data-bv-product-id=${hit.id}
                data-bv-redirect-url=${algoliaShopify.helpers.instantsearchLink(
              hit
            )}
                data-bv-seo="false"
              ></div>`}
            </div>
          </div>
          ${window.brCompareData ? html`
          <fieldset class="relative z-10 text-left">
            <legend class="sr-only">Compare Product</legend>
            <div class="ais-Hits-item-card-compare js-compare-product-wrapper ">
              <input type="checkbox" id="compare-product-${hit.id}" class="js-compare-product ais-Hits-item-card-compare-input text-black cursor-pointer hidden [.active-compare_&]:inline-block" data-hit="${escapeAttr(JSON.stringify(hit))}" data-id="${hit.id}" data-url="${algoliaShopify.helpers.instantsearchLink(hit)}" data-title="${escapeAttr(hit.title)}" data-img="${escapeAttr(hit.product_image)}" name="compare" value="${escapeAttr(hit.id)}" />
              <label for="compare-product-${hit.id}" class="p1 ml-[8px] cursor-pointer hidden [.active-compare_&]:inline-block">Compare</label>
            </div>
          </fieldset>
          ` : html``}
        </div>
      `;
    }
  );
});


function toggleWishlist(productCard) {
  let wishlist = productCard.querySelector(".ais-hit--wishlist");
  if (wishlist.dataset.heartFilled !== "true") {
    wishlist.querySelector(".wishlist__heart-full").style.display = "block";
    wishlist.querySelector(".wishlist__heart-empty").style.display = "none";
    wishlist.setAttribute("data-heart-filled", true);
  } else {
    wishlist.querySelector(".wishlist__heart-full").style.display = "none";
    wishlist.querySelector(".wishlist__heart-empty").style.display = "block";
    wishlist.setAttribute("data-heart-filled", false);
  }
}

async function makeRequest(path, method, payload = null) {
  try {
    const endpoint = window.BARREL.sbdApiUrl;
    const token = window.BARREL.sbdApiAccessToken;
    const url = `${endpoint}/${path}`;

    const reqConfig = {
      method,
      headers: {
        token,
        mode: "no-cors",
      },
    };
    if (payload) {
      reqConfig.headers["Content-Type"] = "application/json";
      reqConfig.body = JSON.stringify(payload);
    }
    const response = await fetch(url, reqConfig);
    if (!response.ok) {
      throw new Error(`${response.status} - ${response.statusText}`);
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(`Error makeRequest: ${method} - ${error}`);
  }
}

async function handleChangeWishlist(event) {
  event.preventDefault();
  event.stopPropagation();
  const customerId = window.BARREL.customerId;
  if (!customerId) {
    window.location.href = "/account/login";
  }
  let productCard = event.target.closest(".ais-product");

  if (productCard.dataset.wishlistId) {
    const result = await makeRequest("removeWishListItem", "POST", {
      customerId,
      wishListItemId: productCard.dataset.wishlistId,
    });
    if (result) {
      toggleWishlist(productCard);
      productCard.removeAttribute("data-wishlist-id");
    }
  } else {
    const result = await makeRequest("addWishListItem", "POST", {
      customerId,
      productId: productCard.dataset.productId,
      handle: productCard.dataset.handle,
      variantId: productCard.dataset.variantId,
      qty: productCard.dataset.qty,
      // title: productCard.dataset.title,
    });
    if (result) {
      toggleWishlist(productCard);
      productCard.setAttribute("data-wishlist-id", result.data.wishListItemId);
    }
  }
}

async function loadWishlistItems() {
  try {
    const customerId = window.BARREL.customerId;
    if (!customerId) {
      return;
    }
    const pageSize = 1000;

    const response = await makeRequest(
      `wishlist/list/${customerId}?pageSize=${pageSize}`,
      "GET"
    );
    if (response) {
      const wishlistItems = response.data;
      for (let i = 0; i < wishlistItems.length; i++) {
        const { wishListItemID, productID } = wishlistItems[i];
        const productCard = document.querySelector(
          `[data-product-id="${productID}"]`
        );
        if (productCard) {
          productCard.setAttribute("data-wishlist-id", wishListItemID);
          // toggleWishlist(productCard);
          let wishlist = productCard.querySelector(".ais-hit--wishlist");

          wishlist.querySelector(".wishlist__heart-full").style.display =
            "block";
          wishlist.querySelector(".wishlist__heart-empty").style.display =
            "none";
          wishlist.setAttribute("data-heart-filled", true);
        }
      }
    }
  } catch (error) {
    console.error("Error loadWishlistItems: ", error.message);
  }
}

const indexPrefix = window.algoliaShopify.config.index_prefix
let activeDataTypes = {}
let query = new URLSearchParams(window.location.search).get('q') || '';
let hitsPerPageAlt = {
  [`${indexPrefix}products`]: 5,
  [`${indexPrefix}pages`]: 5,
  [`${indexPrefix}articles_filtered`]: 5,
  [`${indexPrefix}articles_faq_2`]: 5
};

let pageState = {};
let resultCache = {};
let stopObserver = null;

document.addEventListener("algolia.instantSearch.onRender", async (e) => {
  let wishlistItems = document.querySelectorAll(".ais-hit--wishlist");
  let productCards = document.querySelectorAll(".js-product-card");
  let priceRangeFacet = document.querySelector(".ais-facet-price_range");
  let compareProductEls = document.querySelectorAll(".js-compare-product");
  const tabs = document.querySelectorAll('.js-ais-tab');
  const tabProductCount = document.querySelector('.js-ais-tab-product-count');
  const appId = window.algoliaShopify.config.app_id
  const searchApiKey = window.algoliaShopify.config.search_api_key
  const hitsPerPageProduct = window.algoliaShopify.config.products_full_results_hits_per_page

  activeDataTypes = {
    [`${indexPrefix}products`]: true,
    [`${indexPrefix}pages`]: settings.pages.enabled,
    [`${indexPrefix}articles_filtered`]: settings.pages.enabled,
    [`${indexPrefix}articles_faq`]: settings.articles.enabled
  };

  pageState = {
    [`${indexPrefix}products`]: 0,
    [`${indexPrefix}pages`]: 0,
    [`${indexPrefix}articles_filtered`]: 0,
    [`${indexPrefix}articles_faq`]: 0
  };

  hitsPerPageAlt = {
    [`${indexPrefix}products`]: hitsPerPageProduct,
    [`${indexPrefix}pages`]: 8,
    [`${indexPrefix}articles_filtered`]: 8,
    [`${indexPrefix}articles_faq`]: 10
  }

  if (!window.hasFetchedResults && appId && searchApiKey) {
    window.hasFetchedResults = true;
    fetchResults(appId, searchApiKey);
  }

  if (tabProductCount && !query) {
    tabProductCount.innerText = window.totalSearchResult;
  }

  if (priceRangeFacet) {
    let priceRangeList = priceRangeFacet.querySelector(".ais-RefinementList-list");
    if (priceRangeList && priceRangeList.children.length == 1 && priceRangeList.querySelector(".ais-facet--label.zero-price_range-disable")) {
      priceRangeFacet.classList.add("hidden");
    }
  }
  await loadCTAButton(productCards);

  if (wishlistItems.length) {
    await loadWishlistItems();
    wishlistItems.forEach((ele) => {
      ele.addEventListener("click", handleChangeWishlist);
      ele.addEventListener("keydown", (event) => {
        if (event.key === " " || event.key === "Enter" || event.key === "Spacebar") {
          handleChangeWishlist(event);
        }
      })
    });
  }

  // initial current product compare
  const initialCompareProduct = () => {
    const currentCompareProducts = localStorage.getItem('compareProducts')
    if (currentCompareProducts) {
      const products = JSON.parse(currentCompareProducts)
      products.forEach(product => {
        const id = 'compare-product-' + product.id
        const el = document.getElementById(id)
        if (el) {
          el.checked = true
        }
      })
    }
  }

  const navigationType = performance.getEntriesByType('navigation')[0].type;

  // Function to check if the navigation is a pagination or a reload
  const isPaginationOrReload = () => {
    // Check if the current URL contains a pagination parameter or if it's a reload
    const urlParams = new URLSearchParams(window.location.search);
    const isPagination = urlParams.has('page'); // Assuming pagination uses a 'page' query parameter
    return navigationType === 'reload' || isPagination;
  };

  if (!isPaginationOrReload() && !window.removeCompareProductsState) {
    // If it's not a reload or pagination, remove compareProducts from localStorage
    localStorage.removeItem('compareProducts');
    window.removeCompareProductsState = true
  } else {
    // If it's a reload or pagination, initialize the compare products
    initialCompareProduct();
  }

  //custom event
  const eventCompareProduct = new Event("compare-product")
  const eventCompareProductLimit = new Event("compare-product-limit")

  const currentProducts = localStorage.getItem('compareProducts')
  const data = JSON.parse(currentProducts) || []

  if (data.length) {
    window.dispatchEvent(eventCompareProduct)
  }

  compareProductEls?.forEach((el) => {
    const wrapper = el.closest('.js-compare-product-wrapper')
    wrapper && wrapper.classList.add('active-compare')
    el.addEventListener("change", (e) => {
      const currentProducts = localStorage.getItem('compareProducts');
      let products = JSON.parse(currentProducts) || [];
      const data = Object.fromEntries(Object.entries(e.target.dataset)); // Convert DOMStringMap to object
      const hasProduct = products.some(product => product.id.toString() === data.id.toString());


      if (e.target.checked) {
        const productData = {
          event: "select_item",
          ecommerce: {
            item_list_name: "Compare Checkbox",
            items: [
              {
                item_id: data.id,
                item_name: data.title,
                item_category: JSON.parse(data.hit)?.product_type || "",
                item_brand: JSON.parse(data.hit)?.vendor || ""
              }
            ]
          }
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(productData);
      }

      if (e.target.checked) {
        // If the checkbox is checked, add the product
        if (!hasProduct && products.length < 4) {
          products.push(data); // Add the new product
          localStorage.setItem('compareProducts', JSON.stringify(products));
          window.dispatchEvent(eventCompareProduct);
        } else if (hasProduct) {
          console.log('Product already added');
          // Optionally handle the case where the product is already added
        } else {
          e.preventDefault();
          e.target.checked = false;
          window.dispatchEvent(eventCompareProductLimit);
          window.toggleModal();
        }
      } else {
        // If the checkbox is unchecked, remove the product
        if (hasProduct) {
          products = products.filter(product => product.id.toString() !== data.id.toString());
          localStorage.setItem('compareProducts', JSON.stringify(products));
          window.dispatchEvent(eventCompareProduct);
        }
      }
    });
  });

  if (tabs.length > 0) {
    tabs.forEach(tab => {
      if (!tab.classList.contains('js-event-binded')) {
        tab.addEventListener('click', () => {
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          const tabType = tab.dataset.tab;
          renderTab(tabType);
        });
        tab.classList.add('js-event-binded');
      }
    });
  }
});

async function renderTab(type) {
  const wrapperContainer = document.querySelector('#algolia-shopify-instantsearch')
  if (type === `${indexPrefix}products`) {
    document.querySelectorAll('.js-results-group').forEach(el => {
      el.style.display = 'none';
    });

    const container = document.querySelector(`.results-${type}`);
    container.style.display = '';
    wrapperContainer?.classList.remove("disable-search-header")
    return
  } else {
    wrapperContainer?.classList.add("disable-search-header")
  }

  document.querySelectorAll('.js-results-group').forEach(el => {
    el.style.display = 'none';
  });

  const container = document.querySelector(`.results-${type}`);
  if (!container) return;

  container.style.display = 'block';
  const result = resultCache[type];


  if (type === `${indexPrefix}pages`) {
    container.innerHTML = '';

    const pageResults = resultCache[`${indexPrefix}pages`];
    const articleResults = resultCache[`${indexPrefix}articles_filtered`];
    const pageHits = pageResults?.hits || [];
    const articleHits = articleResults?.hits || [];

    const hasNoResults = pageHits.length === 0 && articleHits.length === 0;

    const noResultsHTML = `
      <div class="ais-hit-empty !mt-[30px] !mb-[40px] !pt-[40px] !lg:mb-[50px] !lg:pt-[100px]">
        <h3 class="ais-hit-empty--content text-left text-2md font-semibold lg:text-lg">
          No results were found. Please try searching for something else.
        </h3>
      </div>
    `;

    if (hasNoResults) {
      container.innerHTML = noResultsHTML;
      return;
    }

    // Reusable block generator
    const createSectionBlock = async ({ title, hits, nbHits, renderFn, paginationKey, extraClass = '' }) => {
      if (hits.length === 0) {
        const emptyDiv = document.createElement('div');
        emptyDiv.className = `${title.toLowerCase()}-list-no-result`;
        emptyDiv.innerHTML = noResultsHTML;
        container.appendChild(emptyDiv);
        return;
      }

      const heading = document.createElement('h3');
      heading.className = `h4 ${extraClass}`;
      heading.textContent = `${escapeHTML(title)} (${nbHits})`;
      container.appendChild(heading);

      const list = document.createElement('ol');
      list.className = 'ais-Hits-list grid grid-cols-1 md:grid-cols-2 gap-6 mt-10';
      const skeletons = hits.map(() => {
        const li = document.createElement('li');
        li.className = 'ais-Hits-item';
        li.innerHTML = `
          <div class="skeleton-card animate-pulse bg-white rounded-[14px] border">
            <div class="skeleton-image aspect-[322/223] md:aspect-[288/332] bg-gray-200 rounded-md"></div>
            <div class="!p-[28px_28px_30px_23px]">
              <div class="animate-pulse bg-gray-200 h-4 rounded w-3/4"></div>
            </div>
          </div>
        `;
        return li;
      });
      skeletons.forEach(li => list.appendChild(li));
      container.appendChild(list);

      const cards = await Promise.all(hits.map(async (hit, idx) => {
        const card = await renderFn(hit);
        return { index: idx, card };
      }));

      cards.forEach(({ index, card }) => {
        if (card instanceof HTMLElement) {
          const li = list.children[index];
          li.innerHTML = '';
          card.classList.add(`order-${(index % 4) + 1}`);
          li.appendChild(card);
        }
      });

      const pagination = renderPagination(resultCache[paginationKey].nbPages, pageState[paginationKey], paginationKey);
      if (pagination) container.appendChild(pagination);
    };

    // Render Pages Section
    await createSectionBlock({
      title: settings.pages.pages_label || 'Pages',
      hits: pageHits,
      nbHits: pageResults.nbHits,
      renderFn: renderPageCard,
      paginationKey: `${indexPrefix}pages`,
      extraClass: ''
    });

    // Render Articles Section
    await createSectionBlock({
      title: settings.pages.articles_label || 'Articles',
      hits: articleHits,
      nbHits: articleResults.nbHits,
      renderFn: renderPageCard,
      paginationKey: `${indexPrefix}articles_filtered`,
      extraClass: 'pt-8 mt-8 lg:mt-10 lg:pt-10 xl:mt-14 xl:pt-14 mb-4 border-t border-solid border-dark-grey'
    });

  } else {
    container.classList.remove('no-result')
    const oldPaginationEls = container.querySelectorAll('.pagination')
    if (oldPaginationEls.length) {
      oldPaginationEls.forEach(el => {
        el.remove()
      })
    }

    const cards = await Promise.all(result.hits.map(async (hit, idx) => {
      let card;
      card = await renderArticleCard(hit);
      return { index: idx, card };
    }));

    const wrapperEl = document.querySelector('accordion-list .js-custom-wrapper')
    const accordionEl = container.querySelector('accordion-list')
    wrapperEl.innerHTML = ''

    if (!result || result.hits.length === 0) {
      container.classList.add('no-result')
      wrapperEl.innerHTML = `<div class="ais-hit-empty !mt-[30px] !mb-[40px] !pt-[40px] !lg:mb-[50px] !lg:pt-[100px]">
        <h3 class="ais-hit-empty--content text-left text-2md font-semibold lg:text-lg">No results were found. Please try searching for something else.</h3>
      </div>`;
      return;
    }

    cards.forEach(({ index, card }) => {
      wrapperEl.appendChild(card);
    });
    accordionEl.initAfterRender()

    const pagination = renderPagination(result.nbPages, pageState[type], type);
    if (pagination) {
      container.appendChild(pagination);
    }
  }
};

async function renderPageCard(hit, idx) {
  let pageUrl = '#'
  let imageUrl = settings.fallback_image || ''

  if (hit.blog) {
    const articlesCustomData = await fetchPageDataByHandle(hit.handle, hit);
    imageUrl = articlesCustomData?.featured_image || settings.fallback_image
    pageUrl = articlesCustomData?.url || `blogs/${hit.blog.handle}/${hit.handle}`
  } else {
    const pageData = await fetchPageDataByHandle(hit.handle);
    imageUrl =
      pageData?.image && pageData.image !== 'null'
        ? pageData.image
        : settings.fallback_image;
    pageUrl = pageData?.url
  }
  const card = document.createElement('div');
  card.className = 'page-card';
  const title = hit.title || 'Untitled';
  const hasImage = !!imageUrl;

  card.innerHTML = `
    <a href=${pageUrl} class="page-card__inner shadow-none hover:shadow-xl transition-all rounded-[14px] overflow-hidden">
      <div class="aspect-[322/223] md:aspect-[288/332] relative">
      ${hasImage
      ? `<img src="${imageUrl}" alt="${escapeHTML(title)}" class="page-card__image" />`
      : `<div class="bg-transparent page-card__image"></div>`
    }
      </div>
      <div class="h4 !p-[28px_28px_30px_23px]">
        ${escapeHTML(title)}
      </div>
    </a>
  `;

  return card;
}

async function renderArticleCard(hit) {
  const card = document.createElement('li');
  card.className = 'article-card accordion__item js-item';
  const title = hit.title || 'Untitled';

  card.innerHTML = `
    <button class="text-left accordion__btn js-btn" type="button">
      ${escapeHTML(title)}
      <span class="absolute -top-4 left-0 w-full h-[calc(100%+30px)]"></span>
      <span class="accordion__icon"></span>
    </button>
    <div class="accordion__content js-content">
      <div class="wysiwyg p1 accordion__content-inner">
    ${DOMPurify.sanitize(hit.body_html)}
      </div>
    </div>
  `;

  return card;
}

function renderPagination(totalPages, currentPage, indexKey) {
  if (totalPages <= 1) return ''
  const nav = document.createElement('nav');
  nav.setAttribute('role', 'navigation');
  nav.setAttribute('aria-label', 'Pagination Navigation');
  nav.className = 'pagination mt-12';
  const appId = window.algoliaShopify.config.app_id
  const searchApiKey = window.algoliaShopify.config.search_api_key

  const ul = document.createElement('ul');
  ul.className = 'h5 flex items-center justify-center';

  const createArrow = (direction, page, disabled) => {
    const li = document.createElement('li');
    li.className = 'pagination__arrow';

    const btn = document.createElement('button');
    btn.className = `flex items-center justify-center pagination__arrow-next-prev pagination__arrow-${direction}`;
    btn.setAttribute('aria-label', direction === 'prev' ? 'Prev' : 'Next');

    if (disabled) {
      btn.classList.add('is-disabled');
      btn.disabled = true;
    } else {
      btn.onclick = () => {
        pageState[indexKey] = page;
        if (query && appId && searchApiKey) {
          fetchResults(appId, searchApiKey);
        }
        document.querySelector('.ais-page, .ais-header-wrapper')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      };
    }

    btn.innerHTML = renderArrowIcon(direction);
    li.appendChild(btn);
    return li;
  };

  const createPage = (page, isActive = false, isEllipsis = false) => {
    const li = document.createElement('li');
    li.className = 'pagination__page !mx-[5px]';

    if (isEllipsis) {
      li.classList.add('is-disabled');
      const span = document.createElement('span');
      span.className = 'pagination__page-link';
      span.textContent = '…';
      li.appendChild(span);
    } else if (isActive) {
      li.classList.add('is-active');
      const span = document.createElement('span');
      span.setAttribute("aria-current", "page")
      span.className = 'is-active pagination__page-link';
      span.textContent = `${page}`;
      li.appendChild(span);
    } else {
      const btn = document.createElement('button');
      btn.className = 'pagination__page-link';
      btn.setAttribute('aria-label', `Goto Page ${page}`);
      btn.setAttribute('type', 'button');
      btn.textContent = `${page}`;
      btn.onclick = () => {
        pageState[indexKey] = page - 1;
        if (query && appId && searchApiKey) {
          fetchResults(appId, searchApiKey);
        }
        document.querySelector('.ais-page, .ais-header-wrapper')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      };
      li.appendChild(btn);
    }

    return li;
  };

  ul.appendChild(createArrow('prev', currentPage - 1, currentPage === 0));

  if (totalPages <= 7) {
    for (let i = 0; i < totalPages; i++) {
      ul.appendChild(createPage(i + 1, i === currentPage));
    }
  } else {
    ul.appendChild(createPage(1, currentPage === 0));

    if (currentPage > 2) {
      ul.appendChild(createPage(null, false, true)); // …
    }

    const start = Math.max(1, currentPage - 1);
    const end = Math.min(totalPages - 2, currentPage + 1);

    for (let i = start; i <= end; i++) {
      ul.appendChild(createPage(i + 1, i === currentPage));
    }

    if (currentPage < totalPages - 3) {
      ul.appendChild(createPage(null, false, true)); // …
    }

    ul.appendChild(createPage(totalPages, currentPage === totalPages - 1));
  }

  // → arrow
  ul.appendChild(createArrow('next', currentPage + 1, currentPage === totalPages - 1));

  nav.appendChild(ul);
  return nav;
}

function renderArrowIcon(direction) {
  if (direction === 'prev') {
    return `
    <div class="icon inline-flex justify-center items-center rounded-full w-[38px] h-[38px]">
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
        <circle cx="13" cy="13" r="13" fill="#fff"></circle>
        <path d="m13.676 9-4.5 4.5 4.5 4.5M18.176 13.5h-8.96" stroke="#000"></path>
      </svg>
    </div>`;
  } else {
    return `
    <div class="icon inline-flex justify-center items-center rounded-full w-[38px] h-[38px]">
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
        <circle cx="13" cy="13" r="13" transform="rotate(-180 13 13)" fill="#fff"></circle>
        <path d="m13.324 18 4.5-4.5-4.5-4.5M8.824 13.5h8.96" stroke="#000"></path>
      </svg>
    </div>`;
  }
}

async function fetchPageDataByHandle(handle, articleData = null) {
  if (articleData) {
    try {
      const res = await fetch(`/blogs/${articleData.blog.handle}/${handle}?view=data`);
      if (!res.ok) throw new Error(`Failed to fetch page: ${res.status}`);
      const data = await res.json();
      return data;
    } catch (err) {
      console.error('Error fetching page data:', err);
      return null;
    }
  } else {
    try {
      const res = await fetch(`/pages/${handle}?view=page-data`);
      if (!res.ok) throw new Error(`Failed to fetch page: ${res.status}`);
      const data = await res.json();
      return data;
    } catch (err) {
      console.error('Error fetching page data:', err);
      return null;
    }
  }
}

async function fetchResults(appId, searchApiKey) {
  const sectionEl = document.querySelector('.ais-page')
  const wrapperSectionEl = document.querySelector('#algolia-shopify-instantsearch')

  const appIdSearch = window.algoliaShopify.config.app_id.toLowerCase();
  const endpoint = `https://${appIdSearch}-3.algolianet.com/1/indexes/*/queries`;
  const headers = {
    'Content-Type': 'application/json',
    'X-Algolia-API-Key': searchApiKey,
    'X-Algolia-Application-Id': appId
  };

  const requests = Object.keys(activeDataTypes)
    .filter(key => activeDataTypes[key])
    .map(key => {
      const baseParams = `query=${query}&hitsPerPage=${hitsPerPageAlt[key]}&page=${pageState[key]}`;
      const withFilter = key.includes('articles') && key.includes('faq') && pageState[key] !== undefined
        ? `${baseParams}&filters=tags:faq`
        : baseParams;
      return {
        indexName: key,
        params: withFilter
      };
    });

  const body = JSON.stringify({ requests });

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers,
      body
    });
    const data = await response.json();

    data.results.forEach((res, idx) => {
      const indexKey = requests[idx].indexName;
      resultCache[indexKey] = res;
    });

    document.querySelectorAll('.js-ais-tab').forEach(tab => {
      const type = tab.dataset.tab;

      if (type.includes('pages')) {
        const pageHits = resultCache[type]?.nbHits || 0;
        const articleFilteredHits = resultCache[type.replace('pages', 'articles_filtered')]?.nbHits || 0;
        tab.querySelector('span').innerHTML = `${pageHits + articleFilteredHits}`;
      } else {
        const result = resultCache[type];
        if (result) {
          tab.querySelector('span').innerHTML = `${result.nbHits}`;
        }
      }
    });

    const tabs = [...document.querySelectorAll('.js-ais-tab')];
    const currentActiveTab = tabs.find(tab => tab.classList.contains('active'));

    const activeTabKey = currentActiveTab?.dataset.tab;
    const isPagesTab = activeTabKey === `${indexPrefix}pages`;
    const tabHasHits = isPagesTab
      ? (resultCache[`${indexPrefix}pages`]?.nbHits || 0) +
      (resultCache[`${indexPrefix}articles_filtered`]?.nbHits || 0) > 0
      : resultCache[activeTabKey]?.nbHits > 0;

    // Only change the active tab if the current tab has no results
    if (!tabHasHits) {
      tabs.forEach(tab => tab.classList.remove('active'));
      const tabToActivate = tabs.find(tab => {
        const tabKey = tab.dataset.tab;
        const isPageTab = tabKey === `${indexPrefix}pages`;
        return isPageTab
          ? (resultCache[`${indexPrefix}pages`]?.nbHits || 0) +
          (resultCache[`${indexPrefix}articles_filtered`]?.nbHits || 0) > 0
          : resultCache[tabKey]?.nbHits > 0;
      }) || tabs[0];
      tabToActivate.classList.add('active');
      renderTab(tabToActivate.dataset.tab);
    } else {
      // Keep the current tab active and just update its content
      renderTab(currentActiveTab.dataset.tab);
    }

    stopObserver = observeElementOnce('.ais-stats--nb-results, .ais-stats-search-query', (countEl) => {
      let totalCount = 0;

      Object.values(resultCache).forEach(result => {
        if (result?.nbHits) totalCount += result.nbHits;
      });

      countEl.textContent = `${totalCount} results for "${query}"`;
      if (window.templateName == "search") {
        document.title = `Search: ${totalCount} for "${query}"`;
      }

      if (totalCount === 0) {
        sectionEl.classList.add('no-result');
      } else {
        sectionEl.classList.remove('no-result');
      }
    });
    sectionEl.classList.remove('is-loading');
    wrapperSectionEl?.classList.add('loaded');
  } catch (error) {
    console.error('Error fetching search results:', error);
  }
}

function observeElementOnce(selector, callback) {
  const el = document.querySelector(selector);
  if (el) return callback(el);

  const observer = new MutationObserver((mutationsList, observerInstance) => {
    const found = document.querySelector(selector);
    if (found) {
      observerInstance.disconnect();
      callback(found);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
}

function ProductBadges(hit, html) {
  let { tags, price, compare_at_price: comparePrice } = hit;
  const availableForSale = true;
  const isBundle = false;

  const handleize = (string) =>
    string
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");

  let badges = [];
  let uniqueBadges = [];
  let max = 2;
  if (comparePrice > price) {
    badges.push("Sale");
  }
  const labelClass =
    "mr-1 mb-1 p-1 p2 font-bold product-card__badge bg-blue text-white";
  const sortRules =
    "badge:Best Seller,badge:New,badge:Gift Guide,badge:Available on B+D,badge:,badge_custom:";
  const sortRulesArr = sortRules.split(",");

  if (tags && tags.length > 0) {
    sortRulesArr.forEach((rule) => {
      if (tags.includes(rule)) {
        badges.push(rule.replace("badge:", ""));
      }
      if (rule === "badge:") {
        const listBadge = tags.filter(
          (tag) => !sortRulesArr.includes(tag) && tag.includes("badge:")
        );
        if (listBadge.length) {
          badges = badges.concat(
            listBadge.map((tag) => tag.replace("badge:", ""))
          );
        }
      }

      if (rule === "badge_custom:") {
        const listBadgeCustom = tags.filter(
          (tag) => !sortRulesArr.includes(tag) && tag.includes("badge_custom:")
        );
        if (listBadgeCustom.length) {
          badges = badges.concat(
            listBadgeCustom.map((tag) => tag.replace("badge_custom:", ""))
          );
        }
      }
    });
  }

  if (badges.length > max) {
    badges = badges.slice(0, max);
  }

  let hideSaleTag = false;
  if (
    tags &&
    tags.includes("available:online") &&
    !tags.includes("D2C-Restriction")
  ) {
    if (availableForSale || isBundle) {
      hideSaleTag = false;
    } else {
      hideSaleTag = true;
    }
  } else {
    hideSaleTag = true;
  }
  uniqueBadges = [...new Set(badges)];
  badges = uniqueBadges;

  if (hideSaleTag) {
    badges = badges.filter((e) => e !== "Sale");
  }

  if (!badges.length) return "";

  return html`<div
    className="product-card__badges empty:hidden mt-2 mb-1 flex flex-wrap"
  >
    ${badges.map((tag) => {
    return html`<div className="flex">
        <span class="badge ${labelClass} bg-${handleize(tag)}">${tag}</span>
      </div>`;
  })}
  </div>`;
}

function storefrontClient(query, variables, version) {
  version = version || '2022-07'

  const endpoint = `https://${window.BARREL.shop}/api/${version}/graphql.json`;
  const method = "POST";
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Shopify-Storefront-Access-Token": window.BARREL.storefrontAccessToken,
  };

  return fetch(endpoint, {
    method: method,
    headers: headers,
    body: JSON.stringify({
      query: query,
      ...(variables && { variables })
    }),
  }).then((response) => response.json());
}

const fetchProductDetails = async (id) => {
  try {
    const res = await storefrontClient(`query {
    product(id: "gid://shopify/Product/${id}") {
      free_gift_meta: metafield(namespace: "plp_filter", key: "free_gift") {
        id
        value
      }
      variants(first: 10){
        nodes{
            id
            availableForSale
        }
      }
    }
  }`);

    return {
      free_gift_meta: res.data?.product?.free_gift_meta?.value || null,
      variants: res.data?.product?.variants?.nodes || [],
    };
  } catch (err) {
    console.error("error", err);
  }
};

async function loadFreeProduct(productData, freeGiftItemSKU) {
  const handle = freeGiftItemSKU;
  const response = await storefrontClient(`{
        product(handle: "${handle}") {
          id
          handle
          title
          featuredImage { id }
          descriptionHtml
          onlineStoreUrl
          vendor
          variants(first: 1) {
            nodes {
              id
              title
              sku
              price { amount }
              availableForSale
            }
          }
        }
    }`);
  if (response.data) {
    const { product: freeProduct } = response.data;
    const variantAvailable = productData.variants.find(
      (variant) => variant.availableForSale
    );
    let variantAvailableId = variantAvailable?.id
      ? variantAvailable.id.replace("gid://shopify/ProductVariant/", "")
      : "";
    if (productData.product_type !== "Bundle" && !variantAvailable?.id) return;

    const activeVariant = freeProduct?.variants?.nodes?.filter(
      (variant) => variant.availableForSale
    )[0];

    if (activeVariant !== undefined) {
      const variantId = activeVariant.id.replace(
        "gid://shopify/ProductVariant/",
        ""
      );
      const formData = {
        items: [
          {
            id: variantAvailableId,
            quantity: 1,
          },
          {
            id: variantId,
            quantity: 1,
          },
        ],
        sections: "site-header,cart",
        sections_url: window.location.pathname,
      };
      document.querySelector("shopify-cart").addItem(formData);
    } else {
      const variantAvailable = productData.variants.find(
        (variant) => variant.availableForSale
      );
      if (productData.product_type !== "Bundle" && !variantAvailable?.id)
        return;

      const formData = {
        items: [
          {
            id: variantAvailableId,
            quantity: 1,
          },
        ],
        sections: "site-header,cart",
        sections_url: window.location.pathname,
      };
      document.querySelector("shopify-cart").addItem(formData);
    }
  }
}

const addToCart = async (event, productData, bundleComponents) => {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  const freeGiftItemSKU = productData.free_gift;
  if (freeGiftItemSKU) {
    await loadFreeProduct(productData, freeGiftItemSKU);
  } else {
    const variantAvailable = productData.variants.find(
      (variant) => variant.availableForSale
    );

    const variantId = variantAvailable
      ? variantAvailable.id.replace("gid://shopify/ProductVariant/", "")
      : productData.objectID;

    const formData = {
      items:
        [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      sections: "site-header,cart",
      sections_url: window.location.pathname,
    };

    let parameter_1 = 'Quick Add';
    let searchTerm = '';

    if (location.pathname.includes('/collections/')) {
      parameter_1 = 'Collection page';
    } else if (location.pathname.includes('/search')) {
      parameter_1 = 'Search';
      searchTerm = new URLSearchParams(location.search).get('q') || '';
    } else if (location.pathname.includes('/products/')) {
      parameter_1 = 'Product page';
    }

    await document.querySelector("shopify-cart").addItem(formData);
    const item = {
      item_id: productData.sku || variantId,
      item_name: productData.title,
      item_brand: productData.vendor,
      index: productData.__hitIndex || 0,
      item_category: productData.vendor,
      collections: [
        ...productData.collections,
      ],
      item_variant: variantAvailable?.title || '',
      price: productData?.price || 0,
      quantity: 1
    };

    const payload = {
      event: 'add_to_cart',
      ecommerce: {
        items: [item]
      },
      parameter_1
    };

    if (searchTerm) payload.search_term = searchTerm;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }
};

async function loadCTAButton(productCards) {
  for (let i = 0; i < productCards.length; i++) {
    const item = productCards[i];
    const productData = item.dataset?.productJson
      ? JSON.parse(item.dataset.productJson)
      : {};
    let {
      product_type: productType,
      can_order: available,
      id: productId,
      handle,
      price,
      compare_at_price: comparePrice,
      tags,
    } = productData;

    let parent = item.querySelector(".js-cta-button");

    const { free_gift_meta, variants } =
      await fetchProductDetails(productId);
    productData["variants"] = variants;
    productData["free_gift"] = free_gift_meta;

    if (tags.includes("D2C-Restriction")) {
      let newChild = document.createElement("a");
      newChild.className =
        "btn-primary cursor-pointer w-full max-w-[183px] px-4 !m-0 h-[45px]";
      newChild.textContent = "View Details";
      newChild.href = `/products/${handle}`;
      newChild.type = "button";
      newChild.addEventListener("click", (event) => {
        trackProductClick(productData);
      });

      parent.replaceChild(newChild, parent.firstChild);
    } else if (tags.includes("available:online") && productType === "Bundle") {

      if (
        productData["inventory_available"]
      ) {
        let newChild = document.createElement("button");
        newChild.className =
          "btn-primary cursor-pointer w-full max-w-[183px] px-4 !m-0 h-[45px]";
        if (!productData["inventory_available"]) {
          newChild.disabled = true;
        }

        newChild.textContent = "Add to Cart";
        newChild.type = "button";
        newChild.addEventListener("click", (event) => {
          trackProductClick(productData);
          addToCart(event, productData, null)
        });
        parent.replaceChild(newChild, parent.firstChild);
      } else {
        parent.firstChild.textContent = "Coming Soon";
        parent.firstChild.disabled = true;
      }

    } else if (
      tags.includes("available:online") &&
      available &&
      productType !== "Bundle"
    ) {
      let newChild = document.createElement("button");
      newChild.className =
        "btn-primary cursor-pointer w-full max-w-[183px] px-4 !m-0 h-[45px]";
      newChild.textContent = "Add to Cart";
      newChild.type = "button";
      newChild.addEventListener("click", (event) => {
        trackProductClick(productData);
        addToCart(event, productData, null)
      });
      parent.replaceChild(newChild, parent.firstChild);
    } else {
      let newChild = document.createElement("a");
      newChild.className =
        "btn-primary cursor-pointer w-full max-w-[183px] px-4 !m-0 h-[45px]";
      newChild.textContent = "View Details";
      newChild.href = `/products/${handle}`;
      // newChild.type = "button";
      newChild.addEventListener("click", (event) => {
        trackProductClick(productData);
      });
      parent.replaceChild(newChild, parent.firstChild);
    }
  }
}

function shouldDisplayProductPrice(product, isBundle) {
  // Check if the product has the required tag and doesn't contain restricted tags.
  const hasOnlineTag = product.tags.includes("available:online");
  const hasRestrictedTags =
    product.tags.includes("MAPP") || product.tags.includes("D2C-Restriction");

  // Check if the product is available or it's a bundle.
  const isProductAvailable = product.can_order || isBundle || product.inventory_available;

  // Determine whether to render the price card.
  return hasOnlineTag && !hasRestrictedTags && isProductAvailable;
}

function renderProductPriceCard(product, html) {
  const isBundle = product.product_type === "Bundle";

  if (shouldDisplayProductPrice(product, isBundle)) {
    const regularPriceLabel = "Regular Price";
    const salePriceLabel = "Sale Price";
    const isOnSale = product.compare_at_price > product.price ? true : false;

    const price = formatMoney(product.price);
    const compareAtPrice = formatMoney(product.compare_at_price);

    const priceHTML = html`
      <div
        regular-price-label="${regularPriceLabel}"
        sale-price-label="${salePriceLabel}"
        price="${price}"
        compare-at-price="${compareAtPrice}"
        ${isBundle ? "hidden" : ""}
      >
        ${isOnSale
        ? html`<div>
              <span class="sr-only"> ${regularPriceLabel} </span>
              <s class="mr-1">${compareAtPrice}</s>
              <span class="sr-only"> ${salePriceLabel} </span>
              <strong>${price}</strong>
            </div>`
        : html`<span>${price}</span>`}
      </div>
    `;

    return priceHTML;
  }
  return ""; // Return empty string if conditions aren't met.
}

function formatMoney(amount) {
  return `$${amount.toFixed(2)}`; // Adjust based on currency formatting needs.
}

function dollarsToCents(amount) {
  return Math.round(
    100 *
    parseFloat(
      typeof amount === "string" ? amount.replace(/[$,]/g, "") : amount
    )
  );
}



function trackProductClick(productData) {
  if (!productData) {
    console.warn("Missing product data. Skipping Algolia click event.");
    return;
  }

  const objectID = productData.objectID;
  const queryID = productData.__queryID || productData.queryID;
  const index = productData.index || productData.__hitIndex;
  const position = Number(productData.__position || productData.productPosition || 1);
  const productId = productData.id;

  const clickedObject = {
    eventName: "Product Clicked",
    objectIDs: [objectID],
    queryID,
    index,
    productId,
    positions: [position],
  };

  try {
    // Update localStorage
    const storageKey = 'algolia_analytics_clicked_objects';
    const existing = JSON.parse(localStorage.getItem(storageKey) || '[]');
    const updated = existing.filter(obj => obj.objectIDs[0] !== productData.objectID);
    updated.push(clickedObject);
    localStorage.setItem(storageKey, JSON.stringify(updated));


  } catch (err) {
    console.error("Failed to track product click:", err);
  }
}


document.addEventListener(
  "click",
  function (e) {
    try {
      // Ignore Add-To-Cart buttons
      if (e.target.closest(".ais-hit--cart-button")) return;

      const productEl = e.target.closest(".ais-product");
      if (!productEl) return;

      const payload = {
        objectID: productEl.dataset.algoliaObjectid,
        queryID: productEl.dataset.algoliaQueryid,
        index: productEl.dataset.algoliaIndex,
        id: productEl.dataset.productId,
        productPosition: productEl.dataset.algoliaPosition
      };

      if (!payload.objectID || !payload.queryID || !payload.index) return;

      if (typeof window.trackProductClick === "function") {
        window.trackProductClick(payload);
      }
    } catch (err) {
      console.error("Delegated click tracking error:", err);
    }
  },
  true
);

window.trackProductClick = trackProductClick;

function getCookieValue(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}


//filter

function buildContainerSelector(selector) {
  return `.ais-facet-meta\\.${selector.replace(/\./g, '\\.')}`;
}

function parseMenuItems(menuItems, unit = "") {
  const lines = menuItems
    .split("\n")
    .map(l => l.trim())
    .filter(Boolean);

  return lines.map((line, idx) => {
    if (line.toLowerCase() === "all") {
      return { label: "All" };
    }
    if (line.includes("-")) {
      const [start, end] = line.split("-").map(Number);
      return { label: `${start} - ${end} ${unit}`.trim(), start, end };
    }
    const value = Number(line);
    if (idx === 1) {
      return { label: `Up to ${value} ${unit}`.trim(), end: value };
    }
    return { label: `Over ${value} ${unit}`.trim(), start: value };
  });
}


function addDynamicCSS(filterSettings) {
  const style = document.createElement("style");
  style.type = "text/css";

  const rules = Object.values(filterSettings)
    .filter(({ containerSelector }) => containerSelector && containerSelector.trim() !== "")
    .map(({ containerSelector }) => {
      const safeSelector = containerSelector.replace(/\./g, "\\.");
      return `
        .ais-facet-dropdown-wrapper.ais-facet-meta\\.${safeSelector} {
          display: flex;
          flex-direction: column-reverse;
        }

        .ais-facet-dropdown-wrapper.ais-facet-meta\\.${safeSelector} .ais-NumericMenu-radio[type='radio'] {
          border-radius: unset;
        }

        .ais-facet-dropdown-wrapper.ais-facet-meta\\.${safeSelector} .ais-NumericMenu-radio[type='radio']:checked {
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3E%3C/svg%3E");
        }
      `;
    })
    .join("\n");

  if (rules.trim() !== "") {
    style.appendChild(document.createTextNode(rules));
    document.head.appendChild(style);
  } else {
    console.warn("⚠️ No valid containerSelector found in filterSettings to generate CSS.");
  }
}